var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "page noselect" },
    [
      _c(
        "v-container",
        { attrs: { "grid-list-xl": "" } },
        [
          _c("h2", { staticClass: "myTitle mt-5 text-center" }, [
            _vm._v("Meine Favoriten"),
          ]),
          _vm.favFoods.length < 1 && _vm.favDrinks.length < 1
            ? _c("div", { staticClass: "pt-4 text-center" }, [
                _vm._v(" Du hast noch keine Favoriten ausgewählt "),
              ])
            : _vm._e(),
          _vm.favFoods.length > 0
            ? _c(
                "v-layout",
                { attrs: { row: "", wrap: "" } },
                _vm._l(_vm.favFoods, function (food, index) {
                  return _c(
                    "v-flex",
                    {
                      staticClass: "pt-2 pb-1 pl-2 pr-2",
                      attrs: { xs6: "", md4: "" },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "tile myBoxShadow pointer",
                          on: {
                            "&click": function ($event) {
                              return _vm.gotoFood(food.id)
                            },
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "itemImage withloader" },
                            [
                              _c(
                                "v-avatar",
                                {
                                  attrs: {
                                    color: "#888",
                                    height: "180",
                                    width: "180",
                                  },
                                },
                                [
                                  _vm.hasImage(food)
                                    ? _c("img", { attrs: { src: food.image } })
                                    : _c("img", {
                                        attrs: {
                                          alt: "App",
                                          src: require("../assets/placeholder6-opti.png"),
                                        },
                                      }),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c("div", { staticClass: "itemName bfont" }, [
                            _vm._v(_vm._s(food.nameToDisplay)),
                          ]),
                          _c("div", { staticClass: "fextras" }, [
                            _vm._v(
                              _vm._s(_vm._f("stringList")(food.extrasToDisplay))
                            ),
                          ]),
                          _c(
                            "div",
                            {
                              staticClass: "deleteIcon",
                              on: {
                                "&click": function ($event) {
                                  $event.stopPropagation()
                                  return _vm.removeFavFood(food.id)
                                },
                              },
                            },
                            [
                              _c(
                                "v-icon",
                                { attrs: { medium: "", color: "accent" } },
                                [_vm._v("mdi-close-circle")]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]
                  )
                }),
                1
              )
            : _vm._e(),
          _vm.favDrinks.length > 0
            ? _c(
                "v-layout",
                { attrs: { row: "", wrap: "" } },
                _vm._l(_vm.favDrinks, function (drink, index) {
                  return _c(
                    "v-flex",
                    {
                      staticClass: "pt-2 pb-1 pl-2 pr-2",
                      attrs: { xs6: "", md4: "" },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "tile myBoxShadow pointer",
                          on: {
                            "&click": function ($event) {
                              return _vm.gotoDrink(drink.id)
                            },
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "itemImage withloader" },
                            [
                              _c(
                                "v-avatar",
                                {
                                  attrs: {
                                    color: "#888",
                                    height: "180",
                                    width: "180",
                                  },
                                },
                                [
                                  _vm.hasImage(drink)
                                    ? _c("img", { attrs: { src: drink.image } })
                                    : _c("img", {
                                        attrs: {
                                          alt: "App",
                                          src: require("../assets/placeholder6-opti.png"),
                                        },
                                      }),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c("div", { staticClass: "itemName bfont" }, [
                            _vm._v(_vm._s(drink.nameToDisplay)),
                          ]),
                          _c("div", { staticClass: "fextras" }, [
                            _vm._v(
                              _vm._s(
                                _vm._f("stringList")(drink.extrasToDisplay)
                              )
                            ),
                          ]),
                          _c(
                            "div",
                            {
                              staticClass: "deleteIcon",
                              on: {
                                "&click": function ($event) {
                                  $event.stopPropagation()
                                  return _vm.removeFaDrink(drink.id)
                                },
                              },
                            },
                            [
                              _c(
                                "v-icon",
                                { attrs: { medium: "", color: "accent" } },
                                [_vm._v("mdi-close-circle")]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]
                  )
                }),
                1
              )
            : _vm._e(),
          _vm.last1Orders.length > 0
            ? _c(
                "v-layout",
                { attrs: { row: "", wrap: "" } },
                [
                  _c("v-flex", { staticClass: "pt-10", attrs: { xs12: "" } }, [
                    _c("h3", { staticClass: "text-center" }, [
                      _vm._v("Letzte Bestellung(en) wiederholen"),
                    ]),
                  ]),
                  _vm._l(_vm.last1Orders, function (order, index) {
                    return _c(
                      "v-flex",
                      {
                        staticClass: "pt-2 pb-1 pl-2 pr-2",
                        attrs: { xs12: "", md6: "" },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "orderItemsBox myBoxShadow" },
                          [
                            _c("ItemDetails", {
                              attrs: { order: order, "with-total": false },
                            }),
                            _c(
                              "div",
                              { staticClass: "flexJustifyCenter mt-7" },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "btn-df",
                                    attrs: { rounded: "" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.reOrder(order)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      { attrs: { left: "", medium: "" } },
                                      [_vm._v(" mdi-cart-arrow-down ")]
                                    ),
                                    _vm._v(" Zum Korb hinzufügen "),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    )
                  }),
                ],
                2
              )
            : _vm._e(),
          _c("div", { staticClass: "spacer-25" }),
          _c("div", { staticClass: "spacer-25" }),
          _c(
            "div",
            { staticClass: "text-center" },
            [
              _c(
                "v-btn",
                {
                  staticClass: "btn-df okBtn text-none",
                  staticStyle: { width: "auto" },
                  attrs: { rounded: "" },
                  nativeOn: {
                    "&click": function ($event) {
                      return _vm.gotoSortiment.apply(null, arguments)
                    },
                  },
                },
                [
                  _vm._v(" Zu unserem Sortiment "),
                  _c("v-icon", { attrs: { right: "", medium: "" } }, [
                    _vm._v("mdi-arrow-right"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "spacer-25" }),
        ],
        1
      ),
      _c("FixBasket"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }